import { render, staticRenderFns } from "./PowerGeneration.vue?vue&type=template&id=2aec3819&scoped=true&"
import script from "./PowerGeneration.vue?vue&type=script&lang=js&"
export * from "./PowerGeneration.vue?vue&type=script&lang=js&"
import style0 from "./PowerGeneration.vue?vue&type=style&index=0&id=2aec3819&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aec3819",
  null
  
)

export default component.exports